//import errorHandler from './errorHandler'
import api from '../../../api'
import _ from 'lodash'

export default {
    get : (payload, next) => {
        api.get('/api/v1/workspaceusers?workspaceId=' + payload._id , (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getByUsers : (payload, next) => {
        api.get('/api/v1/workspaceusers?userId=' + payload._id , (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    add : (payload, next) => {
        api.post('/api/v1/workspaceusers', payload, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    addWith : (payload, next) => {
        api.post('/api/v1/workspaceusers?with=InvitationEmail', payload, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    delete : (payload, next) => {
        api.delete('/api/v1/workspaceusers/5c3e059ee792de1452422b20/pages/5c1a3f0e8db61a7137233446', (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    addAccount : (payload, next) => {
        api.put('/api/v1/workspaceusers/' + payload.query.userId + '/pages', payload.body, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    deleteAccount : (payload, next) => {
        api.delete('/api/v1/workspaceusers/' + payload.query.workspaceuserId + '/pages/' + payload.query.pageId, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    deleteTag : (payload, next) => {
        api.delete('/api/v1/workspaceusers/' + payload.workspaceuserId + '/tags/' + payload.tagId , (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    deleteWorkspaceUser : (payload, next) => {
        api.delete('/api/v1/workspaceusers/' + payload.workspaceuserId, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    setVisible : (payload, next) => {
        api.post('/api/v1/workspaceusers/' + payload.query.workspaceuserId + '/visibleUsers', payload.body, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    deleteVisible : (payload, next) => {
        api.delete('/api/v1/workspaceusers/' + payload.query.workspaceuserId + '/visibleUsers/' + payload.query.visibleUserId, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    }
} 



// WEBPACK FOOTER //
// ./src/libs/system/services/workspaceusers.js